import React from 'react';

interface VenereDoctorProps {
  size?: number;
  className?: string;
  color?: string;
  onClick?: () => void;
}

export const VenereDoctor: React.FC<VenereDoctorProps> = ({
  size = 24,
  className = '',
  color = 'currentColor',
  onClick,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 2000 2000"
      fill={color}
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <path d="M1526.07,789.56c-116.07,0-210.43,94.37-210.43,210.43,0,97.79,67.34,179.46,157.82,202.94v86.41c0,188.53-153.42,341.94-341.94,341.94s-341.94-153.42-341.94-341.94v-29.39c236.41-26.3,420.87-227.07,420.87-470.38v-263.04c0-71.22-47.68-130.86-112.58-150.46-19.6-64.91-79.24-112.58-150.46-112.58-87,0-157.82,70.82-157.82,157.82s70.82,157.82,157.82,157.82c62.67,0,116.53-37.02,141.98-90.09,9.73,9.54,15.85,22.75,15.85,37.48v263.04c0,203.06-165.19,368.26-368.26,368.26s-368.26-165.19-368.26-368.26v-263.04c0-14.73,6.12-27.95,15.85-37.48,25.45,53.07,79.31,90.09,141.98,90.09,87,0,157.82-70.82,157.82-157.82s-70.82-157.82-157.82-157.82c-71.22,0-130.86,47.68-150.46,112.58-64.91,19.6-112.58,79.24-112.58,150.46v263.04c0,243.31,184.46,444.08,420.87,470.38v29.39c0,246.54,200.63,447.16,447.16,447.16s447.16-200.63,447.16-447.16v-86.41c90.49-23.48,157.82-105.15,157.82-202.94,0-116.07-94.37-210.43-210.43-210.43h0ZM947.38,473.91c-29,0-52.61-23.61-52.61-52.61s23.61-52.61,52.61-52.61,52.61,23.61,52.61,52.61-23.61,52.61-52.61,52.61ZM526.52,368.7c29,0,52.61,23.61,52.61,52.61s-23.61,52.61-52.61,52.61-52.61-23.61-52.61-52.61,23.61-52.61,52.61-52.61ZM1526.07,1105.21c-58,0-105.22-47.22-105.22-105.22s47.22-105.22,105.22-105.22,105.22,47.22,105.22,105.22-47.22,105.22-105.22,105.22Z"/>
    </svg>
  );
};

export default VenereDoctor; 